/** Bottom sheet. Closes on backdrop tap and on Escape; the body scrolls. */

import { useEffect, type ReactNode } from 'react'

export function Sheet({ title, onClose, children, onBack }: {
  title: string; onClose: () => void; children: ReactNode; onBack?: (() => void) | null
}) {
  useEffect(() => {
    const k = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose() }
    window.addEventListener('keydown', k)
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => { window.removeEventListener('keydown', k); document.body.style.overflow = prev }
  }, [onClose])
  return (
    <div className="sheet-backdrop" onPointerDown={(e) => { if (e.target === e.currentTarget) onClose() }}>
      <div className="sheet" role="dialog" aria-label={title}>
        <div className="sheet-head">
          {onBack ? <button className="linky" onClick={onBack} aria-label="Back">‹ Back</button> : <span />}
          <h2 style={{ flex: 1, textAlign: onBack ? 'center' : 'left' }}>{title}</h2>
          <button className="secondary" style={{ marginTop: 0, minHeight: 36, padding: '.3rem .8rem' }}
            onClick={onClose}>Done</button>
        </div>
        {children}
      </div>
    </div>
  )
}
